import type { ITSPayloadBet } from '../../@types/ITSPayload.js';
import type { ITS_PRODUCT_ID } from '../../@types/Product.js';
import BoardSportkryss, { type ITSSportkryssBoard } from '../board/BoardSportkryss.js';
import Bet from './Bet.js';

/**
 * Bet class for Sportkryss.
 * Contains product specific logic for this product.
 */
class BetSportkryss extends Bet<BoardSportkryss> {
  override get itsProductId(): (typeof ITS_PRODUCT_ID)[keyof typeof ITS_PRODUCT_ID] {
    return 'SPORTJOKER';
  }

  override get price(): number {
    return super.price * 10; // Sportkryss has a fixed row price of 10kr
  }

  getSystemLabel(): string {
    return `S ${this.getRowCount()}`;
  }

  /**
   * Creates a compact string containing relevant information about the bet to be logged.
   *
   * @returns String to log
   */
  override toString(): string {
    const boardsStrings = this.boards.map((board) => board.toString());

    // For Sportkryss we are only intrested in the product id, boards and row price
    const logEntries = [`pID:${this.product}`, boardsStrings.join('|'), `RP:${this.rowPrice}`];
    return logEntries.join(' ');
  }

  composeOwnRowsBoards(): ITSPayloadBet<undefined> {
    return undefined as ITSPayloadBet<undefined>;
  }

  protected composeBoards(): ITSPayloadBet<{
    jokerBoards: ITSSportkryssBoard[];
  }> {
    const boards = this.boards.map((board) => board.compose());

    const itsPayload = { jokerBoards: boards };

    type ITSBetSportkryss = ITSPayloadBet<typeof itsPayload>;

    return itsPayload as ITSBetSportkryss;
  }

  protected getBoard(): BoardSportkryss {
    return new BoardSportkryss(this.product);
  }
}

export default BetSportkryss;
